import addInfoToggles from "./infoToggles";

export default function initNoCalc(calculatorElement, salePossibilities) {
    let calculatorData = JSON.parse(calculatorElement.dataset.calculator);
    let currency = calculatorData["currency"];

    let fieldnames = [["ticket-", "ticket_fee"], ["presale-", "adavance_booking_fee"], ["customer-", "customer_pay"], ["footer-end", "your_revenue"]];

    for (let sale of salePossibilities) {
        if (calculatorData[(sale + "_hide_cost_model")] === "1") {
            calculatorElement.querySelector('.pricetype-container-' + sale).remove();
            continue;
        }
        for (let currentFieldnames of fieldnames) {
            calculatorElement.querySelector(`.calculator-${currentFieldnames[0]}price-${sale}`).innerText = formatNoCalcPrice(calculatorData[`${sale}_fix_${currentFieldnames[1]}`], currency);
        }
    }

    let swiperEl = calculatorElement.querySelector('.slider');
    if (swiperEl.swiper !== undefined) {
        swiperEl.swiper.update();
    }

    addInfoToggles(calculatorElement);
}

function formatNoCalcPrice(price, currency) {
    if (price == 0) {
        return "-";
    }
    return `${currency} ${price}`;
}
